import styled from '@emotion/styled';
import {
  Accordion as MUIAccordion,
  AccordionDetails as MUIAccordionDetails,
  AccordionSummary as MUIAccordionSummary,
} from '@mui/material';
import tw from 'twin.macro';

import ChevronIcon from '../../../assets/svg/ChevronIcon';

const StyledAccordion = styled(MUIAccordion)`
  ${tw`!m-0 shadow-none`}

  &::before {
    ${tw`!hidden`}
  }

  .MuiButtonBase-root {
    ${tw`w-fit`}
  }
`;

const StyledAccordionSummary = styled(MUIAccordionSummary)`
  ${tw`w-full p-0 !min-h-[44px]`}

  .MuiAccordionSummary-content {
    ${tw`!m-0`}
  }
`;

const StyledAccordionDetails = styled(MUIAccordionDetails)`
  ${tw`p-0`}
`;

export const Accordion = ({ children, ...props }) => {
  return <StyledAccordion {...props}>{children}</StyledAccordion>;
};

export const AccordionSummary = ({ children, ...props }) => {
  return (
    <StyledAccordionSummary
      expandIcon={<ChevronIcon className="w-5 h-5 !text-brand-1000" />}
      {...props}
    >
      {children}
    </StyledAccordionSummary>
  );
};

export const AccordionDetails = ({ children, ...props }) => {
  return <StyledAccordionDetails {...props}>{children}</StyledAccordionDetails>;
};
